<template>
  <div class="items color">
    <ul
      id="sizeList"
      class="d-flex flex-wrap list-unstyled mb-0"
    >
      <li
        v-for="variation in variationsToShow"
        :key="variation.variationId"
      >
        <a
          :href="langPrefix + variation.urlPath"
          :class="{'sold': !variation.hasStock , 'active': variationId === variation.variationId }"
        >
          {{ variation.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    name: 'VariationImageSelection',
    props: {
        variationAttributes: {
            type: Array,
            default: () => []
        },
        variationId: {
            type: Number,
            required: true
        },
        preloadImageLimit: {
            type: Number,
            default: 12
        },
        lang: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            opened: false
        }
    },
    computed: {
        variationsToShow () {
            if (this.opened) {
                return this.variationAttributes
            }
            return this.variationAttributes.slice(0, this.preloadImageLimit)
        },
        langPrefix () {
            return this.lang === App.defaultLanguage ? '' : ('/' + this.lang)
        }
    },
    methods: {
        showMore () {
            this.opened = true
        }
    }
}
</script>

<style scoped>

</style>
